// Phase 1 primary solution categories — how DAAKYI solves customer problems.
// Industry pages (/solutions/:id) remain as the secondary "Industries We Support" layer.

export const solutionCategories = [
  {
    id: 'sovereign-cloud',
    name: 'Sovereign Cloud',
    href: '/solutions/sovereign-cloud',
    audience: 'For organizations with data residency and jurisdictional requirements',
    description: 'Keep regulated data and critical systems inside your chosen jurisdiction, with clear legal footing for where workloads run and who governs them.',
    deliverables: [
      'In-country data residency with regional workload placement',
      'Customer-managed encryption keys and access controls',
      'Dedicated, physically isolated environments where required',
      'Audit trails and evidence for regulators'
    ]
  },
  {
    id: 'enterprise',
    name: 'Enterprise Cloud',
    audience: 'For established organizations modernizing core infrastructure',
    description: 'Move ERP, databases and business systems onto secure cloud infrastructure without re-platforming — with high availability, backup and disaster recovery built in.',
    deliverables: [
      'VM-based landing zones for existing enterprise applications',
      'Zero-downtime migration off VMware and physical servers',
      'High availability, backup and cross-site DR by design',
      'Hybrid connectivity to facilities you keep'
    ]
  },
  {
    id: 'government',
    name: 'Government & Public Sector',
    audience: 'For ministries, agencies and state-owned enterprises',
    description: 'Sovereign digital infrastructure for citizen services and government systems, with the isolation, auditability and continuity that public institutions require.',
    deliverables: [
      'Sovereign hosting for citizen-facing and internal systems',
      'Strict tenant isolation and role-based access',
      'Tamper-evident audit logging of every action',
      'Continuity planning with rehearsed recovery'
    ]
  },
  {
    id: 'critical-infrastructure',
    name: 'Critical Infrastructure',
    audience: 'For energy, telecommunications, transport and utilities',
    description: 'Infrastructure for systems that cannot fail: segmented networks, continuous data protection, disaster recovery and continuous security monitoring for operators of essential services.',
    deliverables: [
      'Micro-segmented networks separating IT and operational systems',
      'Continuous data protection with second-scale recovery points',
      'Cross-site disaster recovery with dependency-ordered plans',
      'Security operations monitoring with XDR correlation'
    ]
  },
  {
    id: 'msps',
    name: 'Managed Service Providers',
    audience: 'For MSPs and IT service companies serving their own clients',
    description: 'Build managed offerings on DAAKYI infrastructure: multi-tenant Virtual Data Centers, per-client quotas and metering, and an open API for your own tooling.',
    deliverables: [
      'Virtual Data Centers with per-client quotas and isolation',
      'Usage metering to support client billing',
      'Full REST API for automation and integration',
      'White-glove support from DAAKYI engineers'
    ]
  },
  {
    id: 'smes-startups',
    name: 'SMEs & Startups',
    audience: 'For growing businesses that need enterprise infrastructure without the overhead',
    description: 'Start with what you need — a few VMs, storage and backup — on the same secure platform used by enterprises and government, and grow without replatforming.',
    deliverables: [
      'Right-sized VM, storage and networking configurations',
      'Security and backup enabled by default, not bolted on',
      'Managed options when you lack in-house operations staff',
      'A platform that scales as the business grows'
    ]
  }
];
